import React from "react";
import { Link } from "react-router-dom";
import { Heart, MapPin, Clock, Star } from "lucide-react";
import { useApp } from "@/context/AppContext";

function timeAgo(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 60) return `acum ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `acum ${h}h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `acum ${d} zile`;
  return new Date(iso).toLocaleDateString("ro-RO");
}

export default function ListingCard({ listing, compact = false }) {
  const { isFav, toggleFavorite } = useApp();
  const fav = isFav(listing.id);

  return (
    <div className="amd-card rounded-lg overflow-hidden group relative fade-in">
      <Link to={`/anunt/${listing.id}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden bg-black">
          {listing.images?.[0] ? (
            <img
              src={listing.images[0]}
              alt={listing.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : <div className="w-full h-full grid place-items-center text-xs" style={{ color: "var(--amd-text-muted)" }}>Fără imagine</div>}
          {listing.featured && (
            <span className="absolute top-2 left-2 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded text-white flex items-center gap-1" style={{ background: "var(--amd-primary)" }}>
              <Star className="w-3 h-3" /> Promovat
            </span>
          )}
          {listing.status === "pending" && (
            <span className="absolute top-2 left-2 text-[10px] font-bold uppercase px-2 py-1 rounded bg-yellow-500/90 text-black">În verificare</span>
          )}
          {listing.status === "sold" && (
            <span className="absolute top-2 left-2 text-[10px] font-bold uppercase px-2 py-1 rounded bg-green-600 text-white">Vândut</span>
          )}
        </div>
      </Link>
      <button
        onClick={(e) => { e.preventDefault(); toggleFavorite(listing.id); }}
        className="absolute top-2 right-2 w-9 h-9 rounded-full grid place-items-center backdrop-blur-sm transition-colors"
        style={{ background: "rgba(0,0,0,0.55)" }}
        aria-label="favorite"
      >
        <Heart className={`w-4 h-4 ${fav ? "fill-current" : ""}`} style={{ color: fav ? "var(--amd-primary)" : "#fff" }} />
      </button>
      <Link to={`/anunt/${listing.id}`} className="block p-3">
        <h3 className={`font-semibold text-white line-clamp-2 ${compact ? "text-sm min-h-[2.5rem]" : "text-[15px] min-h-[2.75rem]"}`}>
          {listing.title}
        </h3>
        <div className="mt-2 font-black text-lg" style={{ color: "var(--amd-primary)" }}>
          {Number(listing.price).toLocaleString("ro-RO")} {listing.currency}
        </div>
        <div className="mt-2 flex items-center justify-between text-xs" style={{ color: "var(--amd-text-muted)" }}>
          <span className="flex items-center gap-1 truncate">
            <MapPin className="w-3 h-3 shrink-0" /> <span className="truncate">{listing.location || listing.city}</span>
          </span>
          <span className="flex items-center gap-1 shrink-0">
            <Clock className="w-3 h-3" /> {timeAgo(listing.created_at)}
          </span>
        </div>
      </Link>
    </div>
  );
}
